export const gameConstants = {
    DOWN_LEFTTIME: 'GAME_DOWN_LEFTTIME',
    FETCH_CONFIG: 'GAME_FETCH_CONFIG',
};
